import { TransportModes } from "../types";

export const generatePleaseSelect = () => ({
  value: null,
  label: "Please select",
  mode: "",
  headsigns: [],
});

const processFn = (_transport: any, mode: TransportModes) => ({
  value: _transport.place.id,
  label: _transport.place.name,
  mode,
  headsigns: _transport.place?.headsigns,
});

const validator = (mode: TransportModes) => (_t: any) => _t.mode === mode;

const generator = (transport: any, mode: TransportModes) => {
  const _transport = transport.transports.find(validator(mode));
  if (_transport) {
    return [processFn(transport, mode)];
  }

  return [];
};

export const generateTransportItems = (transport: any) => {
  if (!transport.transports) {
    return [];
  }

  const highSpeedTrain = generator(transport, "highSpeedTrain");
  const intercityTrain = generator(transport, "intercityTrain");
  const interRegionalTrain = generator(transport, "interRegionalTrain");
  const regionalTrain = generator(transport, "regionalTrain");
  const cityTrain = generator(transport, "cityTrain");
  const bus = generator(transport, "bus");
  const ferry = generator(transport, "ferry");
  const subway = generator(transport, "subway");
  const lightRail = generator(transport, "lightRail");
  const privateBus = generator(transport, "privateBus");
  const inclined = generator(transport, "inclined");
  const aerial = generator(transport, "aerial");
  const busRapid = generator(transport, "busRapid");
  const monorail = generator(transport, "monorail");
  const flight = generator(transport, "flight");
  const walk = generator(transport, "walk");

  return [
    ...highSpeedTrain,
    ...intercityTrain,
    ...interRegionalTrain,
    ...regionalTrain,
    ...cityTrain,
    ...bus,
    ...ferry,
    ...subway,
    ...lightRail,
    ...privateBus,
    ...inclined,
    ...aerial,
    ...busRapid,
    ...monorail,
    ...flight,
    ...walk,
  ].filter((_t: any) => _t.mode !== null);
};
